/* ============
 * Organization Settings
 * ============
 *
 * This is the page for editing the organization settings.
 */
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import Forms from './../../../../utils/forms/forms';
import organizationSettingsTransformer from './../../../../transformers/organizationSettings';
import orderService from './../../../../services/order';
import organizationSettingsService from './../../../../services/organizationSettings';
import messageTemplateTypeService from './../../../../services/messageTemplateType';
import clientGroupService from './../../../../services/client-group';
import accountingProviderService from './../../../../services/accountingProvider';
import clientService from './../../../../services/client';
import shippingService from './../../../../services/shippingProvider';
import supplierService from './../../../../services/supplier';
import productService from './../../../../services/product';
import productTypeService from './../../../../services/productType';
import warehouseService from './../../../../services/warehouse';
import priceFieldService from './../../../../services/priceField';
import advanceService from './../../../../services/advance';
import bulkPriceUpdatePopup from './../../../../components/bulkPriceUpdatePopup/bulkPriceUpdatePopup.vue';

export default {
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      tagsOptions: [],
      ediBillingProcessOptions: [{
        id: 'auto',
        name: this.$t('static.organizationSettings.ediBillingMethod.options.auto'),
      },
      {
        id: 'half-auto',
        name: this.$t('static.organizationSettings.ediBillingMethod.options.halfAuto'),
      },
      {
        id: 'manual',
        name: this.$t('static.organizationSettings.ediBillingMethod.options.manuel'),
      },
      ],
      generalSettingsFormSet1: new Forms({
        tosAccepted: {
          value: '',
          type: 'checkbox',
        },
        marketingAllowed: {
          value: '',
          type: 'checkbox',
        },
        facebookPixelId: {
          value: '',
          type: 'text',
        },
        defaultClientGroupId: {
          value: '',
          type: 'select',
        },
        billingNumberDefault: {
          value: '',
          type: 'number',
        },
        customerNumberDefault: {
          value: '',
          type: 'number',
        },
        supplierNumberDefault: {
          value: '',
          type: 'number',
        },
        orderNumberDefault: {
          value: '',
          type: 'number',
        },
        productNumberInitial: {
          value: '',
          type: 'text',
          maxlength: 3,
        },
        productNumberDefault: {
          value: '',
          type: 'number',
        },
        defaultDueDays: {
          value: '',
          type: 'number',
        },
        penaltyAfter: {
          value: 14,
          type: 'number',
          min: 14,
        },
        roundInvoiceTotal: {
          value: '',
          type: 'checkbox',
        },
        ediBillingProcess: {
          value: '',
          type: 'select',
        },
        defaultProductTypeName: {
          value: '',
          type: 'select',
        },
        // defaultShippingProvider: {
        //   value: '',
        //   type: 'select',
        // },
        defaultWarehouse: {
          value: '',
          type: 'select',
        },
        priceFields: {
          value: [],
          type: 'checkboxGroup',
        },
        visiblePriceFields: {
          value: [],
          type: 'select',
          attributes: {
            multiple: true,
          },
        },
        defaultPriceField: {
          value: '',
          type: 'select',
        },
      }),
      generalSettingsFormSet2: new Forms({
        invoiceNotes: {
          value: '',
          type: 'textarea',
        },
        creditNoteNotes: {
          value: '',
          type: 'textarea',
          required: true,
        },
        customTos: {
          value: '',
          type: 'textarea',
        },
        customOrderProductNote: {
          value: '',
          type: 'textarea',
        },
        billNotes: {
          value: '',
          type: 'textarea',
        },
      }),
      messagesFormSet1: new Forms({
        invoiceEmailTitle: {
          value: '',
          type: 'text',
        },
        invoiceEmailTemplate: {
          value: '',
          type: 'textarea',
        },
      }),
      messagesFormSet2: new Forms({
        creditNoteEmailTitle: {
          value: '',
          type: 'text',
        },
        creditNoteEmailTemplate: {
          value: '',
          type: 'textarea',
        },
      }),
      messagesFormSet3: new Forms({
        reminderEmailTitle: {
          value: '',
          type: 'text',
        },
        reminderEmailTemplate: {
          value: '',
          type: 'textarea',
        },
      }),
      messagesFormSet4: new Forms({
        orderConfirmNotificationEmailTitle: {
          value: '',
          type: 'text',
        },
        orderConfirmNotificationEmailTemplate: {
          value: '',
          type: 'textarea',
        },
      }),
      messagesFormSet5: new Forms({
        orderTrackingEmailTitle: {
          value: '',
          type: 'text',
        },
        orderTrackingEmailTemplate: {
          value: '',
          type: 'textarea',
        },
      }),
      bookingSettingsSet1: new Forms({
        timeslotGap: {
          value: '',
          type: 'number',
        },
        remindersEnabled: {
          value: '',
          type: 'checkbox',
        },
        messageTemplateTypeId: {
          value: '',
          type: 'select',
        },
        smsFrom: {
          value: '',
          type: 'text',
        },
      }),
      accountingFormSet2: new Forms({
        paymentIdentitificationGeneration: {
          value: '',
          type: 'checkbox',
        },
        paymentIdentitificationTemplate: {
          value: '',
          type: 'text',
        },
        paymentIdentitificationNumberLength: {
          value: 10, // Default to 10
          type: 'number',
        },
        paymentIdentitificationModulusType: {
          value: 'Modulus 10',
          type: 'select',
        },
      }),
      accountingFormSet1: new Forms({
        accountingProviderId: {
          value: '',
          type: 'select',
        },
      }),
      emailInvoiceCopyForm: new Forms({
        email_invoice_copy: {
          value: '',
          type: 'text',
        },
      }),
      advanceFormSet: new Forms({
        percentage: {
          value: 3,
          type: 'number',
        },
        enableRounding: {
          value: '',
          type: 'checkbox',
        },
        roundingType: {
          value: '',
          type: 'select',
        },
        priceType: {
          value: '',
          type: 'select',
          attributes: {
            multiple: true,
          },
        },
      }),
      ediNotificationRecipients: [],
      ediNotifyRecipInputVisible: false,
      ediNotifyRecipInputValue: '',
      ediNotifyRecipInvalidValue: '',
      lowStockNotificationRecipients: [],
      lowStockNotifyRecipInputVisible: false,
      lowStockNotifyRecipInvalidValue: '',
      lowStockNotifyRecipInputValue: '',
      loading: false,
      tabIndex: '1',
      bulkPriceUpdateStatus: 'open',
      bulkPriceUpdateEntries: [],
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
      orders: 'allOrders',
      settings: 'organizationSettings',
      templateTypes: 'allMessageTemplateTypes',
      clientGroups: 'allClientGroups',
      accountingProviders: 'allAccountingProviders',
      clients: 'clients',
      suppliers: 'allSuppliers',
      products: 'allProducts',
      productTypes: 'allProductTypes',
      shippingProviders: 'allShippingProviders',
      warehouses: 'allWarehouses',
      priceFields: 'allPriceFields',
    }),

    checkProjectModule() {
      let show = false;
      if (this.account.modules.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'Project') {
            show = true;
          }
        }
      }
      return show;
    },

    isOnlineBooking() {
      return this.account.plan === 'Online Booking' || this.account.plan === 'Booking Pro';
    },

    isEDI() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'EDI') {
            return true;
          }
        }
      }

      return false;
    },

    productInfoDisplay() {
      return this.settings.productInfoDisplay;
    },
    checkHasInventory() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            return true;
          }
        }
      }

      return false;
    },
  },

  watch: {

    $route() {
      this.urlCurrentTab();
    },

    tabIndex(value) {
      this.assignTab(value);
    },

    'advanceFormSet.enableRounding': function (value) {
      if (value === true) {
        this.advanceFormSet.enableField('roundingType');
      } else {
        this.advanceFormSet.disableField('roundingType');
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productTypes    The product types list.
     */
    productTypes(productTypes) {
      if (productTypes) {
        this.generalSettingsFormSet1.setOptions('defaultProductTypeName', productTypes.map(type => ({
          id: type.name,
          name: this.$t(`static.products.types.${this.camalize(type.name)}`),
        })));
      }
    },

    shippingProviders(shippingProviders) {
      this.generalSettingsFormSet1.setOptions('defaultShippingProvider', shippingProviders.map(item => ({
        id: +item.id,
        name: item.name,
      })));
    },

    warehouses(warehouses) {
      this.generalSettingsFormSet1.setOptions('defaultWarehouse', warehouses.items.map(item => ({
        id: +item.id,
        name: item.name,
      })));
    },

    priceFields(priceFields) {
      this.generalSettingsFormSet1.setOptions('priceFields', priceFields.all.map(item => ({
        id: +item.id,
        name: item.name,
      })));
      this.generalSettingsFormSet1.setOptions('defaultPriceField', priceFields.all.map(item => ({
        id: +item.id,
        name: item.name,
      })));
    },

    'generalSettingsFormSet1.priceFields': function (selectedPriceFields) {
      if (selectedPriceFields) {
        this.generalSettingsFormSet1.setOptions('defaultPriceField', this.priceFields.all.filter(item => selectedPriceFields.includes(item.name)).map(item => ({
          id: +item.id,
          name: item.name,
        })));

        this.visiblePrices();
        this.priceTypes();
      }
    },
    /**
     * Watch state of accounting providers to inject to Form class.
     */
    accountingProviders(accountingProviders) {
      this.accountingFormSet1.setOptions('accountingProviderId', accountingProviders);
    },

    /**
     * Watches state of client groups and inject to Forms class.
     */
    clientGroups(clientGroups) {
      this.generalSettingsFormSet1.setOptions('defaultClientGroupId', clientGroups.all);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} settings    The organizationSettings.
     */
    settings(settings) {
      this.generalSettingsFormSet1.assignData(settings);
      this.generalSettingsFormSet1.priceFields = this.priceFields.all.filter(item => settings.priceFields.includes(item.id)).map(item => item.name);
      this.generalSettingsFormSet2.assignData(settings);
      this.messagesFormSet1.assignData(settings);
      this.messagesFormSet2.assignData(settings);
      this.messagesFormSet3.assignData(settings);
      this.messagesFormSet4.assignData(settings);
      this.messagesFormSet5.assignData(settings);
      this.bookingSettingsSet1.assignData(settings);
      this.accountingFormSet1.assignData(settings);
      this.accountingFormSet2.assignData(settings);
      if (settings.paymentIdentitificationNumberLength) {
        this.accountingFormSet2.disableField('paymentIdentitificationGeneration');
        this.accountingFormSet2.disableField('paymentIdentitificationModulusType');
        this.accountingFormSet2.disableField('paymentIdentitificationNumberLength');
        this.accountingFormSet2.disableField('paymentIdentitificationTemplate');
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} settings    The messageTemplateTypes.
     */
    templateTypes(templateTypes) {
      this.generalSettingsFormSet2.setOptions('messageTemplateTypeId', templateTypes);
    },

    // *
    // * Watches state update to inject on Forms class.
    // *
    // * @param  {Object} orders    The orders list.

    // orders(orders) {
    //   if (orders.all.length === 0) {
    //     this.enableDefaultsNumbers();
    //   }
    // },
    // clients(clients) {
    //   if(clients.items.length > 0){
    //     this.generalSettingsFormSet1.disableField('customerNumberDefault');
    //   }
    // },
    // suppliers(suppliers) {
    //     if(suppliers.items.length === 0){
    //        this.generalSettingsFormSet1.enableField('supplierNumberDefault');
    //     }
    // },
    // products(products) {
    //   if(products.length === 0){
    //     this.generalSettingsFormSet1.enableField('productNumberDefault');
    //     this.generalSettingsFormSet1.enableField('productNumberInitial');
    //   }
    // },

    inputValue(inputValue) {
      this.handleInputConfirm();
    },
  },

  mounted() {
    this.disableDefaultsNumbers();
    this.generalSettingsFormSet1.setExtraAttr('productNumberInitial', {
      maxlength: 3,
    });
    this.urlCurrentTab();
    this.assignTab(this.tabIndex);
  },

  created() {
    // console.log( this.$i18n.messages[this.$i18n.locale].form.products);
    const tags = ['sugar', 'alcohol_percentage', 'bottle_volume', 'producer', 'country', 'vintage', 'productPackagingName', 'sku', 'vmp', 'gtin'];
    const allTags = this.$i18n.messages[this.$i18n.locale].form.products;
    this.tagsOptions = Object.keys(allTags).filter(key => tags.includes(key))
      .reduce((obj, key) => {
        obj[key] = allTags[key];
        return obj;
      }, {});

    if (this.$route.params.tab && this.$route.params.tab === 'email') {
      this.tabIndex = '2';
    }

    const requests = [];


    // supplierService.all();
    // productService.all();
    requests.push(clientGroupService.all());
    // requests.push(clientService.items({
    //     page:1,
    //     limit:1,
    //   }));
    this.generalSettingsFormSet1.assignData(this.settings);
    this.generalSettingsFormSet2.assignData(this.settings);
    this.messagesFormSet1.assignData(this.settings);
    this.messagesFormSet2.assignData(this.settings);
    this.messagesFormSet3.assignData(this.settings);
    this.messagesFormSet4.assignData(this.settings);
    this.messagesFormSet5.assignData(this.settings);
    this.bookingSettingsSet1.assignData(this.settings);
    this.accountingFormSet1.assignData(this.settings);
    this.accountingFormSet2.assignData(this.settings);
    this.messagesFormSet1.setTooltip('invoiceEmailTitle', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
    this.messagesFormSet1.setTooltip('invoiceEmailTemplate', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
    this.messagesFormSet2.setTooltip('creditNoteEmailTitle', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
    this.messagesFormSet2.setTooltip('creditNoteEmailTemplate', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
    this.messagesFormSet3.setTooltip('reminderEmailTitle', this.$t('form.organizationSettings.reminderEmailTemplate.tooltip'));
    this.messagesFormSet3.setTooltip('reminderEmailTemplate', this.$t('form.organizationSettings.reminderEmailTemplate.tooltip'));
    this.messagesFormSet4.setTooltip('orderConfirmNotificationEmailTitle', this.$t('form.organizationSettings.orderConfirmNotificationEmailTemplate.tooltip'));
    this.messagesFormSet4.setTooltip('orderConfirmNotificationEmailTemplate', this.$t('form.organizationSettings.orderConfirmNotificationEmailTemplate.tooltip'));
    this.messagesFormSet5.setTooltip('orderTrackingEmailTitle', this.$t('form.organizationSettings.orderTrackingEmailTemplate.tooltip'));
    this.messagesFormSet5.setTooltip('orderTrackingEmailTemplate', this.$t('form.organizationSettings.orderTrackingEmailTemplate.tooltip'));

    // Disabled and hide ediBillingProcess field until fully tested in production.
    // this.generalSettingsFormSet1.setOptions('ediBillingProcess', this.ediBillingProcessOptions);
    this.generalSettingsFormSet1.hideField('ediBillingProcess');

    this.loading = true;
    if (Object.keys(this.settings).length === 0) {
      // requests.push(organizationSettingsService.show());

    }

    if (!this.checkHasInventory) {
      this.generalSettingsFormSet1.hideField('productNumberInitial');
      this.generalSettingsFormSet1.hideField('productNumberDefault');
    }
    requests.push(productTypeService.all());
    requests.push(shippingService.all());
    requests.push(warehouseService.all());
    requests.push(priceFieldService.all());

    if (Object.keys(this.templateTypes).length === 0) {
      requests.push(messageTemplateTypeService.all());
    } else {
      this.bookingSettingsSet1.setOptions('messageTemplateTypeId', this.templateTypes);
    }

    if (Object.keys(this.accountingProviders).length === 0) {
      requests.push(accountingProviderService.all());
    } else {
      this.accountingFormSet1.setOptions('accountingProviderId', this.accountingProviders);
    }

    Promise.all([orderService.counts(), clientService.counts(), supplierService.counts(), productService.counts()]).then((data) => {
      if (data[0].count === 0) {
        this.enableDefaultsNumbers();
      }

      if (data[1].count > 0) {
        this.generalSettingsFormSet1.disableField('customerNumberDefault');
      }

      if (data[2].count === 0) {
        this.generalSettingsFormSet1.enableField('supplierNumberDefault');
      }

      if (data[3].count === 0) {
        this.generalSettingsFormSet1.enableField('productNumberDefault');
        this.generalSettingsFormSet1.enableField('productNumberInitial');
      }
    });
    Promise.all([organizationSettingsService.show()]).then((data) => {
      this.setTags(data[0].productInfoDisplay);
      this.generalSettingsFormSet1.priceFields = this.priceFields.all.filter(item => this.settings.priceFields.includes(item.id)).map(item => item.name);
      this.visiblePrices();
      this.priceTypes();
      this.bulkPriceUpdateStatus = this.settings.bulkPriceUpdateStatus;
      this.bulkPriceUpdateStatusChange(this.bulkPriceUpdateStatus);
      this.bulkPriceUpdateEntries = this.settings.bulkPriceUpdateEntries;
      console.log(this.bulkPriceUpdateEntries);
    });

    Promise.all(requests).then(() => {
      this.loading = false;
    });

    this.advanceFormSet.disableField('roundingType');
    this.generalSettingsFormSet1.setExtraAttr('penaltyAfter', { min: 14 });
    this.penaltyTypes();
    this.roundingTypes();
    this.showEmailInvoiceCopy();
    this.showEdiNotifyRecip();
    this.showLowStockNotifyRecip();
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalClass: 'SET_MODAL_CLASS',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    getPriceTypes(priceTypes) {
      const priceList = Object.values(priceTypes);
      const formattedPriceList = priceList.map(this.camelCaseToReadable);
      const wrappedPriceList = formattedPriceList.map(item => `«${item}»`);
      return wrappedPriceList.join('<br>');
    },

    camelCaseToReadable(str) {
      return str.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase(); // Convert each word to lowercase
    },

    penaltyTypes() {
      const options = [
        { id: 'none', name: 'None' },
        { id: 'penalty_fee', name: 'Penalty Fee' },
        { id: 'default_interest', name: 'Default Interest' },
      ];
      this.generalSettingsFormSet1.setOptions('penaltyTypeForDueInvoice', options);
    },

    roundingTypes() {
      const options = [
        { id: 'nearest-1', name: this.$t('form.organizationSettings.roundingType.options.nearest_1') },
        { id: 'nearest-0.50', name: this.$t('form.organizationSettings.roundingType.options.nearest_0_50') },
        { id: 'nearest-0.25', name: this.$t('form.organizationSettings.roundingType.options.nearest_0_25') },
        { id: 'nearest-0.99', name: this.$t('form.organizationSettings.roundingType.options.nearest_0_99') },
        { id: 'round-half-up', name: this.$t('form.organizationSettings.roundingType.options.round_half_up') },
        { id: 'round-half-down', name: this.$t('form.organizationSettings.roundingType.options.round_half_down') },
        { id: 'round-half-even', name: this.$t('form.organizationSettings.roundingType.options.round_half_even') },
        { id: 'round-towards-zero', name: this.$t('form.organizationSettings.roundingType.options.round_towards_zero') },
        { id: 'round-away-from-zero', name: this.$t('form.organizationSettings.roundingType.options.round_away_from_zero') },
      ];
      this.advanceFormSet.setOptions('roundingType', options);
      this.advanceFormSet.setFieldValue('roundingType', 'nearest-1');
    },

    priceTypes() {
      const options = this.priceFields.all.filter(item => this.settings.priceFields.includes(item.id)).map(item => ({
        id: +item.id,
        name: item.name,
      }));
      this.advanceFormSet.setOptions('priceType', options);
    },

    bulkPriceUpdateStatusChange(status) {
      if (status === 'running' || status === 'failed') {
        this.advanceFormSet.disableField('percentage');
        this.advanceFormSet.disableField('enableRounding');
        this.advanceFormSet.disableField('roundingType');
        this.advanceFormSet.disableField('priceType');
      }
    },

    onBulkPriceUpdate() {
      return advanceService.bulkPriceUpdate(this.advanceFormSet.data())
      .then((res) => {
        this.bulkPriceUpdateStatus = res.data.status;
        this.bulkPriceUpdateStatusChange(this.bulkPriceUpdateStatus);
      })
      .catch(() => {
      });
    },

    bulkPriceUpdateModal() {
      const priceType = this.advanceFormSet.data().priceType;
      const selectedPriceType = this.priceFields.all.filter(obj => priceType.includes(String(obj.id))).map(obj => obj.name);

      this.setModalContent(() => bulkPriceUpdatePopup);
      this.setModalProps({
        info: {
          percentage: this.advanceFormSet.data().percentage,
          enableRounding: this.advanceFormSet.data().enableRounding,
          roundingType: this.advanceFormSet.data().roundingType,
          priceType: selectedPriceType,
        },
        onSubmit: this.onBulkPriceUpdate,
      });
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    visiblePrices() {
      const priceFieldsList = this.priceFields.all.filter(item => this.settings.priceFields.includes(item.id)).map(item => ({
        id: +item.id,
        name: item.name,
      }));
      this.generalSettingsFormSet1.setOptions('visiblePriceFields', priceFieldsList);
    },

    assignTab(value) {
      let tab = '';
      if (value === '7') {
        tab = '#advance';
      } else if (value === '6' && this.checkProjectModule === true) {
        tab = '#projects';
      } else if (value === '5') {
        tab = '#shippingProviders';
      } else if (value === '4') {
        tab = '#accounting';
      } else if (value === '3') {
        tab = '#booking';
      } else if (value === '2') {
        tab = '#email';
      } else {
        tab = '#general';
      }
      history.pushState({}, null, `/#${this.$route.path}${tab}`);
    },

    urlCurrentTab() {
      if (this.$router.currentRoute.hash === '#advance') {
        this.tabIndex = '7';
      } else if (this.$router.currentRoute.hash === '#projects' && this.checkProjectModule === true) {
        this.tabIndex = '6';
      } else if (this.$router.currentRoute.hash === '#shippingProviders') {
        this.tabIndex = '5';
      } else if (this.$router.currentRoute.hash === '#accounting') {
        this.tabIndex = '4';
      } else if (this.$router.currentRoute.hash === '#booking') {
        this.tabIndex = '3';
      } else if (this.$router.currentRoute.hash === '#email') {
        this.tabIndex = '2';
      } else {
        this.tabIndex = '1';
      }
    },

    ediNotifyRecipHandleClose(email) {
      Promise.all([
        organizationSettingsService.ediNotificationRecipients('destroy', { email }),
      ]).then((data) => {
        this.ediNotificationRecipients = data[0];
      }).catch((error) => {
        console.log(error);
      });
    },

    ediNotifyRecipShowInput() {
      this.ediNotifyRecipInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveEmailInput.$refs.input.focus();
      });
    },

    ediNotifyRecipHandleInputConfirm() {
      this.ediNotifyRecipInvalidValue = '';
      const inputValue = this.ediNotifyRecipInputValue;
      if (inputValue) {
        Promise.all([
          organizationSettingsService.ediNotificationRecipients('create', { email: inputValue }),
        ]).then((data) => {
          this.ediNotificationRecipients = data[0];
          this.ediNotifyRecipInputVisible = false;
          this.ediNotifyRecipInputValue = '';
        }).catch((error) => {
          this.ediNotifyRecipInvalidValue = error.email[0];
          console.log(error);
        });
      }
    },

    showEdiNotifyRecip() {
      Promise.all([
        organizationSettingsService.ediNotificationRecipients('show', {}),
      ]).then((data) => {
        this.ediNotificationRecipients = data[0];
      }).catch((error) => {
        console.log(error);
      });
    },

    lowStockNotifyRecipHandleClose(email) {
      Promise.all([
        organizationSettingsService.lowStockNotificationRecipients('destroy', { email }),
      ]).then((data) => {
        this.lowStockNotificationRecipients = data[0];
      }).catch((error) => {
        console.log(error);
      });
    },

    lowStockNotifyRecipShowInput() {
      this.lowStockNotifyRecipInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveEmailInputLowStock.$refs.input.focus();
      });
    },

    lowStockNotifyRecipHandleInputConfirm() {
      this.lowStockNotifyRecipInvalidValue = '';
      const inputValue = this.lowStockNotifyRecipInputValue;
      if (inputValue) {
        Promise.all([
          organizationSettingsService.lowStockNotificationRecipients('create', { email: inputValue }),
        ]).then((data) => {
          this.lowStockNotificationRecipients = data[0];
          this.lowStockNotifyRecipInputVisible = false;
          this.lowStockNotifyRecipInputValue = '';
        }).catch((error) => {
          this.lowStockNotifyRecipInvalidValue = error.email[0];
          console.log(error);
        });
      }
    },

    showLowStockNotifyRecip() {
      Promise.all([
        organizationSettingsService.lowStockNotificationRecipients('show', {}),
      ]).then((data) => {
        this.lowStockNotificationRecipients = data[0];
      }).catch((error) => {
        console.log(error);
      });
    },

    saveEmailInvoiceCopy() {
      this.emailInvoiceCopyForm.loading = true;
      const data = this.emailInvoiceCopyForm.data();
      return new Promise((resolve, reject) => {
        organizationSettingsService.emailInvoiceCopy('createOrUpdate', { email_invoice_copy: data.email_invoice_copy })
              .then((data) => {
                this.emailInvoiceCopyForm.loading = false;
                resolve();
              }).catch((errors) => {
                this.emailInvoiceCopyForm.recordErrors(errors);
                this.emailInvoiceCopyForm.loading = false;
                reject();
              });
      });
    },

    showEmailInvoiceCopy() {
      return new Promise((resolve, reject) => {
        organizationSettingsService.emailInvoiceCopy('display', {})
              .then((data) => {
                this.emailInvoiceCopyForm.setFieldValue('email_invoice_copy', data.data[0]);
                resolve();
              }).catch((error) => {
                  //
                reject();
              });
      });
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    setTags(tag) {
      for (let i = tag.length - 1; i >= 0; i--) {
        this.dynamicTags.push(tag[i]);
      }
    },

    showInput() {
      this.inputVisible = true;
      /* this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.select.focus();
      })*/
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue && !this.dynamicTags.includes(inputValue)) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    enableDefaultsNumbers() {
      this.generalSettingsFormSet1.enableField('billingNumberDefault');
      this.generalSettingsFormSet1.enableField('customerNumberDefault');
      this.generalSettingsFormSet1.enableField('orderNumberDefault');
    },

    disableDefaultsNumbers() {
      this.generalSettingsFormSet1.disableField('billingNumberDefault');
      this.generalSettingsFormSet1.disableField('customerNumberDefault');
      this.generalSettingsFormSet1.disableField('supplierNumberDefault');
      this.generalSettingsFormSet1.disableField('orderNumberDefault');
      this.generalSettingsFormSet1.disableField('productNumberDefault');
      this.generalSettingsFormSet1.disableField('productNumberInitial');
      this.generalSettingsFormSet1.setTooltip('billingNumberDefault', this.$t('static.organizationSettings.disabledFieldTooltips'));
      this.generalSettingsFormSet1.setTooltip('customerNumberDefault', this.$t('static.organizationSettings.disabledFieldTooltips'));
      this.generalSettingsFormSet1.setTooltip('orderNumberDefault', this.$t('static.organizationSettings.disabledFieldTooltips'));
      this.generalSettingsFormSet1.setTooltip('productNumberDefault', this.$t('static.organizationSettings.disabledProductFieldTooltips'));
      this.generalSettingsFormSet1.setTooltip('productNumberInitial', this.$t('static.organizationSettings.disabledProductFieldTooltips'));
    },

    /**
     * This method will be called when saving the form.
     */
    save() {
      this.generalSettingsFormSet1.loading = true;
      this.generalSettingsFormSet2.loading = true;
      const generalSettingsFormSet1Data = this.generalSettingsFormSet1.data();
      generalSettingsFormSet1Data.priceFields = this.priceFields.all.filter(item => generalSettingsFormSet1Data.priceFields.includes(item.name)).map(item => item.id);
      const organizationSettings = organizationSettingsTransformer.send(
        Object.assign({
          productInfoDisplay: this.dynamicTags,
        },
          generalSettingsFormSet1Data,
          this.generalSettingsFormSet2.data())
      );
      organizationSettingsService.update(organizationSettings)
        .then(() => {
          this.generalSettingsFormSet1.loading = false;
          this.generalSettingsFormSet2.loading = false;
          this.generalSettingsFormSet1.successMessage = this.$t('static.organizationSettings.settingsSaveSuccess');
        })
        .catch((errors) => {
          this.generalSettingsFormSet1.loading = false;
          this.generalSettingsFormSet2.loading = false;
          this.generalSettingsFormSet1.recordErrors(errors);
          this.generalSettingsFormSet2.recordErrors(errors);
        });
    },

    saveMessages() {
      this.messagesFormSet1.loading = true;
      this.messagesFormSet2.loading = true;
      this.messagesFormSet3.loading = true;
      this.messagesFormSet4.loading = true;
      this.messagesFormSet5.loading = true;
      const organizationSettings = organizationSettingsTransformer.send(
        Object.assign({},
          this.messagesFormSet1.data(),
          this.messagesFormSet2.data(),
          this.messagesFormSet3.data(),
          this.messagesFormSet4.data(),
          this.messagesFormSet5.data())
      );
      organizationSettingsService.updateMessages(organizationSettings)
        .then(() => {
          this.messagesFormSet1.loading = false;
          this.messagesFormSet2.loading = false;
          this.messagesFormSet3.loading = false;
          this.messagesFormSet4.loading = false;
          this.messagesFormSet5.loading = false;
          this.messagesFormSet5.successMessage = this.$t('static.organizationSettings.settingsSaveSuccess');
        })
        .catch((errors) => {
          this.messagesFormSet1.loading = false;
          this.messagesFormSet2.loading = false;
          this.messagesFormSet3.loading = false;
          this.messagesFormSet4.loading = false;
          this.messagesFormSet5.loading = false;
          this.messagesFormSet1.recordErrors(errors);
          this.messagesFormSet2.recordErrors(errors);
          this.messagesFormSet3.recordErrors(errors);
          this.messagesFormSet4.recordErrors(errors);
          this.messagesFormSet5.recordErrors(errors);
        });
    },

    saveBooking() {
      this.bookingSettingsSet1.loading = true;
      const organizationSettings = organizationSettingsTransformer.send(
        Object.assign({},
          this.bookingSettingsSet1.data())
      );
      organizationSettingsService.updateBooking(organizationSettings)
        .then(() => {
          this.bookingSettingsSet1.loading = false;
          this.bookingSettingsSet1.successMessage = this.$t('static.organizationSettings.settingsSaveSuccess');
        })
        .catch((errors) => {
          this.bookingSettingsSet1.loading = false;
          this.bookingSettingsSet1.recordErrors(errors);
        });
    },
    saveAccounting() {
      this.accountingFormSet1.loading = true;
      const organizationSettings = organizationSettingsTransformer.send(
        Object.assign({},
          this.accountingFormSet1.data())
      );
      organizationSettingsService.updateAccounting(organizationSettings)
        .then(() => {
          this.accountingFormSet1.loading = false;
          this.accountingFormSet1.successMessage = this.$t('static.organizationSettings.settingsSaveSuccess');
        })
        .catch((errors) => {
          this.accountingFormSet1.loading = false;
          this.accountingFormSet1.recordErrors(errors);
        });
    },
    saveBilling() {
      this.accountingFormSet2.loading = true;
      const organizationSettings = organizationSettingsTransformer.send(
        Object.assign({},
          this.accountingFormSet2.data())
      );
      organizationSettingsService.updateBilling(organizationSettings)
        .then(() => {
          this.accountingFormSet2.loading = false;
          this.accountingFormSet2.successMessage = this.$t('static.organizationSettings.settingsSaveSuccess');
        })
        .catch((errors) => {
          this.accountingFormSet2.loading = false;
          this.accountingFormSet2.recordErrors(errors);
        });
    },
    showTagOptions(tag) {
      return `{${tag}} , `;
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    ShippingProviderTable: require('./../../../../components/shippingProviderTable/shippingProviderTable.vue'),
    ChartOfAccounts: require('./../../../../components/chartOfAccounts/chartOfAccounts.vue'),
    ProjectTable: require('./../../../../components/projectTable/projectTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/profile/settings/settings.js